const fields = {};

export default fields;
